import type { FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@dhl/theme'

export const FlagBE: FC<SvgIconProps> = (props) => (
  <SvgIcon width={24} height={20} viewBox="0 0 9 6" {...props}>
    <path fill="#ED2939" d="M0 0h9v6H0z" />
    <path fill="#FAE042" d="M0 0h6v6H0z" />
    <path fill="#000000" d="M0 0h3v6H0z" />
  </SvgIcon>
)
